export interface Cacheable {
  lastUpdatedAt: number;
}

export abstract class CacheableC implements Cacheable {
  /** in milliseconds since 1970 */
  lastUpdatedAt: number = Date.now();
}
